var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78375 6.15841L0.848756 0.239831C0.654303 0.0460292 0.339479 0.046355 0.145352 0.240833C-0.0486252 0.435286 -0.0481241 0.750286 0.146354 0.944238L5.72808 6.51055L0.146152 12.0768C-0.0483016 12.2708 -0.0488029 12.5856 0.145149 12.7801C0.242463 12.8776 0.369952 12.9263 0.49744 12.9263C0.624603 12.9263 0.75159 12.8779 0.848729 12.7811L6.78375 6.86267C6.8774 6.76949 6.92996 6.64267 6.92996 6.51055C6.92996 6.37843 6.87725 6.25176 6.78375 6.15841Z",
    fill: "#272D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b65e292edbce1b12de62dd3fa8cc113f.svg";
export { ForwardRef as ReactComponent };